export const GET_DRIVER_PERMITLIST_STATES="pay-citation/GET_DRIVER_PERMITLIST_STATES";
export const SET_DRIVER_PERMITLIST_STATES = "pay-citation/SET_DRIVER_PERMITLIST_STATES";
export const SET_DRIVER_PERMITLIST_STATES_ERROR = "pay-citation/SET_DRIVER_PERMITLIST_STATES_ERROR";
export const SET_DRIVER_SELECTED_GRID_PERMIT="pay-citation/SET_DRIVER_SELECTED_GRID_PERMIT";
export const SET_DRIVER_PERMIT_RESION="pay-citation/SET_DRIVER_PERMIT_RESION";
export const GET_DRIVER_PERMIT_RESION="pay-citation/GET_DRIVER_PERMIT_RESION";

export const getDriverPermitListStates=(data)=>{
    return{
        type:GET_DRIVER_PERMITLIST_STATES,
        payload:data
    }
}
export const setDriverPermitListStates=(data)=>{
    return{
        type:SET_DRIVER_PERMITLIST_STATES,
        payload:data
    }
}
export const setDriverPermitListStatesError=(data)=>{
    return{
        type:SET_DRIVER_PERMITLIST_STATES_ERROR,
        payload:data
    }
}

export const setDriverSelectedGridPermit=(data)=>{
    return{
        type:SET_DRIVER_SELECTED_GRID_PERMIT,
        payload:data
    }
}

// Virtual Permit Resion Text
export const setDriverPermitResionText = (data) => {
    return{
        type:SET_DRIVER_PERMIT_RESION,
        payload:data
    }
}
export const getDriverPermitResionText = (data) => {
    return{
        type:GET_DRIVER_PERMIT_RESION,
        payload:data
    }
}